module.exports = __webpack_public_path__ + "img/accidental-damage.1dc41bb0.png";